import { deepClone } from '../../utils';
import type { RuntimeActivitySegment } from './types';

export function toRuntimeActivitySegment(msg: any, fallbackAgent = '', fallbackTimestamp = ''): RuntimeActivitySegment | null {
  const activityId = String(msg?.activityId || '').trim();
  if (!activityId) return null;
  return {
    type: 'runtime_activity',
    activityId,
    agent: String(msg?.agent || fallbackAgent || '').trim(),
    kind: String(msg?.kind || 'status').trim(),
    title: String(msg?.title || '').trim(),
    detail: typeof msg?.detail === 'string' ? msg.detail : '',
    status: String(msg?.status || 'running').trim(),
    sourceEventType: typeof msg?.sourceEventType === 'string' ? msg.sourceEventType : '',
    timestamp: typeof msg?.timestamp === 'string' && msg.timestamp ? msg.timestamp : fallbackTimestamp,
    parentActivityId: msg?.parentActivityId || null,
    meta: msg?.meta ? deepClone(msg.meta) : null,
  };
}

export function upsertRuntimeActivitySegment(segments: any[], nextSegment: RuntimeActivitySegment): any[] {
  const list = Array.isArray(segments) ? segments : [];
  const existingIndex = list.findIndex((segment: any) => segment?.type === 'runtime_activity' && segment.activityId === nextSegment.activityId);
  if (existingIndex >= 0) {
    list[existingIndex] = nextSegment;
    return list;
  }
  list.push(nextSegment);
  return list;
}
